export const inputNumber = {
    slots: {
        root: 'h-12',
        base: 'h-full',
    },
}
